import { createAsyncThunk } from "@reduxjs/toolkit";
import { type AxiosResponse } from "axios";
import { awsClientGateway } from "./common/gateway";
import { logMessage } from "../utils/amplifyLogger";
import { clientLog } from "./logging";
import type { RootState } from "../store/types";

type RejectFn = (value: string) => unknown;

interface ContactRecordingParams {
  action: string;
  contactId: string;
  initialContactId: string;
  instanceId: string;
}

const updateContactRecordingState = async (
  { action, contactId, initialContactId, instanceId }: ContactRecordingParams,
  rejectWithValue: RejectFn,
): Promise<AxiosResponse | unknown> => {
  try {
    const response = await awsClientGateway({
      pathTemplate: `/screenRecording/${instanceId}/${contactId}/${initialContactId}/${action}`,
      method: "POST",
    });
    return response;
  } catch (error) {
    clientLog({
      component: `screenRecording`,
      message: `Something went wrong in ${action} contactRecording API => ${error}`,
    });
    logMessage(
      `screenRecording API`,
      `Something went wrong in ${action} screenRecording API => ${error}`,
      `error`,
    );
    return rejectWithValue(`Error in ${action} screenRecording api endpoint`);
  }
};

export interface ScreenRecordingArg {
  action: string;
  contactId: string;
  initialContactId: string;
}

export const updateCotactRecordingStateAction = createAsyncThunk<
  unknown,
  ScreenRecordingArg,
  { state: RootState }
>(
  "screenRecording/update",
  async (args: ScreenRecordingArg, { getState, rejectWithValue }) => {
    const connectedInstance = getState().userInstance.connectedInstance;
    const instanceId = connectedInstance?.instanceId ?? "";
    return await updateContactRecordingState(
      { ...args, instanceId },
      rejectWithValue,
    );
  },
);
